import { Button } from "@heroui/react";
import { DeferredBoundary } from "@hallyulytics/router";
import { AppFrame, MotionBoundary, StreamFallback } from "@hallyulytics/ui";
import { Trans } from "@lingui/react/macro";
import { useLoaderData } from "react-router";
import type { homeLoader } from "../router";

export function HomePage() {
  const data = useLoaderData<typeof homeLoader>();
  return (
    <AppFrame application="admin" locale={data.locale}>
      <main className="page">
        <MotionBoundary>
          <section className="hero">
            <div>
              <div className="eyebrow">Private control plane</div>
              <h1>Operate the platform with evidence.</h1>
              <p>
                Shard health, ingest reachability, immutable audit events, migrations, and restore
                posture in one bounded control surface.
              </p>
              <Button variant="primary">
                <Trans id="admin.review">Review controls</Trans>
              </Button>
            </div>
            <div className="panel">
              <DeferredBoundary
                value={data.checks}
                fallback={<StreamFallback label="Checking private services" />}
                error={<p>Service checks are unavailable.</p>}
              >
                {(checks) => (
                  <dl>
                    {Object.entries(checks).map(([name, status]) => (
                      <div key={name}>
                        <dt>{name}</dt>
                        <dd>{status}</dd>
                      </div>
                    ))}
                  </dl>
                )}
              </DeferredBoundary>
            </div>
          </section>
        </MotionBoundary>
      </main>
    </AppFrame>
  );
}
